import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PermissionConfirmdialogComponent } from 'src/app/feature/admin/dialogues/permission-confirmdialog/permission-confirmdialog.component';
import { Store, select } from '@ngrx/store';
import { mapsPayload } from 'src/app/app-store/map/map.selector';
import { ILanguages } from 'src/app/models/map';
import { userDetailsPayload } from 'src/app/app-store/user/user.selector';
import { UserService } from 'src/app/core/services/user.service';
import { InfoDialogueComponent } from 'src/app/shared/dialogues/infodialog/infodialog.component';
import { GetUserDetailsApiAction } from 'src/app/app-store/user/user.action';
import { GetMapsApiAction } from 'src/app/app-store/map/map.action';

@Component({
  selector: 'app-language-template',
  templateUrl: './language-template.component.html',
  styleUrls: ['./language-template.component.css']
})
export class LanguageTemplateComponent implements OnInit {
  @Input() onStartUp: boolean;
  selectedOption: string;
  languages: ILanguages[];
  isDefault: boolean;
  show: boolean;
  @Output() continue = new EventEmitter<boolean>();


  constructor(
    private translocoService: TranslocoService,
    private dialog: MatDialog,
    private router: Router,
    private userService: UserService,
    private store: Store) { }

  ngOnInit(): void {
    this.store.pipe(select(mapsPayload)).subscribe(response => {
      this.languages = response.languages;
    });
    this.store.pipe(select(userDetailsPayload)).subscribe(response => {
      if (response !== undefined) {
        if (response.preferredLanguage === undefined) {
          this.isDefault = true;
          this.selectedOption = this.languages.filter(item => item.name === 'English').map(language => language.culture)[0];
        } else {
          this.isDefault = false;
          this.selectedOption = this.languages.filter(item => item.name === response.preferredLanguage).map(language => language.culture)[0];
        }
      }
    });
  }
  onApply() {
    this.show = true;
    const language = this.languages.filter(item => item.culture === this.selectedOption).map(lang => lang.name)[0];
    this.userService.postlanguageData(language).subscribe(response => {
      this.show = false;
      if (response.message === undefined) {
        const dialogRef = this.dialog.open(PermissionConfirmdialogComponent, {
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(resp => {
          window.location.reload();
        });
      } else {
        const dialogRef = this.dialog.open(InfoDialogueComponent, {
          disableClose: true,
          data: { status: response.message }
        });
        dialogRef.afterClosed().subscribe(resp => {
        });
      }
    }, error => {
      const dialogRef = this.dialog.open(InfoDialogueComponent, {
        disableClose: true,
        data: { status: this.translocoService.translate('something_wrong') }
      });
      dialogRef.afterClosed().subscribe(response => {
      });
    });
  }
  onContinue() {
    this.show = true;
    this.translocoService.setActiveLang(this.selectedOption);
    const language = this.languages.filter(item => item.culture === this.selectedOption).map(lang => lang.name)[0];
    this.userService.postlanguageData(language).subscribe(response => {
      this.show = false;
      if (response.message === undefined) {
        this.continue.emit(true);
        this.store.dispatch(GetUserDetailsApiAction());
        this.store.dispatch(GetMapsApiAction());
      } else {
        const dialogRef = this.dialog.open(InfoDialogueComponent, {
          disableClose: true,
          data: { status: response.message }
        });
        dialogRef.afterClosed().subscribe(resp => {
          this.continue.emit(false);
        });
      }
    }, error => {
      const dialogRef = this.dialog.open(InfoDialogueComponent, {
        disableClose: true,
        data: { status: this.translocoService.translate('something_wrong') }
      });
      dialogRef.afterClosed().subscribe(response => {
      });
    });

  }
}
